export default __webpack_public_path__ + "static/media/no.62829f71.webp";